import { render, staticRenderFns } from "./helpSetting.vue?vue&type=template&id=50496f34&scoped=true"
import script from "./helpSetting.vue?vue&type=script&lang=js"
export * from "./helpSetting.vue?vue&type=script&lang=js"
import style0 from "./helpSetting.vue?vue&type=style&index=0&id=50496f34&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50496f34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50496f34')) {
      api.createRecord('50496f34', component.options)
    } else {
      api.reload('50496f34', component.options)
    }
    module.hot.accept("./helpSetting.vue?vue&type=template&id=50496f34&scoped=true", function () {
      api.rerender('50496f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/helpSetting.vue"
export default component.exports